import styled from '@emotion/styled'

import type { PendingMatchStatus } from 'src/graphql/types'
import { useProcessing } from 'src/screens/matches/collection/match/status/use-progress'
import { washColor } from 'src/screens/matches/collection/match/status/wash-color'

// Horizontal counterpart to the grid card's ring: a bar across the bottom that
// fills left (0) to right (100%) with the same red -> yellow -> green wash.
export function DefuseBar(props: {
  createdAt: string
  status: PendingMatchStatus
  className?: string
}) {
  const { progress, stalled } = useProcessing(props.createdAt, props.status)

  return (
    <Track className={props.className}>
      <Fill
        style={{
          width: `${progress * 100}%`,
          background: stalled ? washColor(0) : washColor(progress)
        }}
      />
    </Track>
  )
}

const Track = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 4px;
  background: rgba(128, 128, 128, 0.25);
  pointer-events: none;
`

const Fill = styled.div`
  height: 100%;
`
